import React from 'react';
import {
  Button, Col, Icons, Row,
} from '../../../components/base/BootstrapComponents';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';

export const createEmptyPricingStep = () => ({
  units_count: '',
  cost: '',
});

export const normalizePricingStepsForForm = pricingSteps => {
  if (!Array.isArray(pricingSteps) || !pricingSteps.length) {
    return [];
  }

  return pricingSteps.map(step => ({
    units_count: typeof step?.units_count === 'number' ? step.units_count : '',
    cost: typeof step?.cost === 'number' ? step.cost : '',
  }));
};

export const normalizePricingPayload = (pricingMode, pricingSteps) => {
  if (pricingMode !== 'tiered') {
    return undefined;
  }

  return (Array.isArray(pricingSteps) ? pricingSteps : [])
    .map(step => {
      const unitsValue = step?.units_count;
      const costValue = step?.cost;

      return {
        units_count: unitsValue === '' || unitsValue === null || typeof unitsValue === 'undefined'
          ? null
          : Number(unitsValue),
        cost: costValue === '' || costValue === null || typeof costValue === 'undefined'
          ? null
          : Number(costValue),
      };
    })
    .filter(step => step.cost !== null && !Number.isNaN(step.cost));
};

const getDurationLabelKey = timeUnit => {
  switch (timeUnit) {
    case 'minute':
      return 'pricing.step.duration.minutes';
    case 'day':
      return 'pricing.step.duration.days';
    case 'hour':
    default:
      return 'pricing.step.duration.hours';
  }
};

const getHintKey = timeUnit => {
  switch (timeUnit) {
    case 'minute':
      return 'pricing.steps.hint.minutes';
    case 'day':
      return 'pricing.steps.hint.days';
    case 'hour':
    default:
      return 'pricing.steps.hint.hours';
  }
};

export default function PricingStepsEditor(props) {
  const {
    control,
    pricingSteps = [],
    setPricingSteps = () => {},
    disabled = false,
    timeUnit = 'hour',
  } = props;
  const { formatMessage } = intlShape;
  const durationLabelKey = getDurationLabelKey(timeUnit);
  const hintKey = getHintKey(timeUnit);

  const append = () => {
    setPricingSteps([...pricingSteps, createEmptyPricingStep()]);
  };

  const remove = index => {
    const nextSteps = pricingSteps.filter((_, itemIndex) => itemIndex !== index);
    setPricingSteps(nextSteps.length ? nextSteps : [createEmptyPricingStep()]);
  };

  return (
    <div className="pricing-steps-editor">
      <div className="pricing-steps-header">{formatMessage({ id: 'pricing.steps.header' })}</div>
      <div className="pricing-steps-hint">
        {formatMessage({ id: hintKey })}
      </div>
      {pricingSteps.map((step, index) => (
        <div className="pricing-step-row" key={index}>
          <Row className="w-100">
            <Col columns={6}>
              <FieldDTO
                control={control}
                type="number"
                className="mb-2"
                dtoObject={{
                  name: `pricing_steps.${index}.units_count`,
                  type: Number,
                  validators: {},
                  labelKey: durationLabelKey,
                }}
                addPlaceholder
                component={TextInputWithLabel}
                disabled={disabled}
                withLabel
              />
            </Col>
            <Col columns={6}>
              <FieldDTO
                control={control}
                type="number"
                className="mb-2"
                dtoObject={{
                  name: `pricing_steps.${index}.cost`,
                  type: Number,
                  validators: {},
                  labelKey: 'pricing.step.cost',
                }}
                addPlaceholder
                component={TextInputWithLabel}
                disabled={disabled}
                withLabel
              />
            </Col>
          </Row>
          {!disabled
            ? (
              <Button className="pricing-step-remove" onClick={() => remove(index)}>
                <Icons width={24} height={24} customIcon icon="trash" />
              </Button>
            )
            : null}
        </div>
      ))}
      {!disabled
        ? (
          <Button className="btn-sm mb-2 mt-2" onClick={append}>
            Добавить ступень
          </Button>
        )
        : null}
    </div>
  );
}
